import { StatusEnum } from "./status-enum";

export const salesRequestStatusColors = {
  [StatusEnum.PENDING]: "default",
  [StatusEnum.PARTIALLY_ORDERED]: "warning",
  [StatusEnum.FULLY_ORDERED]: "success",
};
